'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactTextInput = require('react-text-input');

var _reactTextInput2 = _interopRequireDefault(_reactTextInput);

var _aphrodite = require('aphrodite');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Name component used to get the user's full name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - used with account creation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - depends on VX and the grid
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var styles = _aphrodite.StyleSheet.create({
	errorMessage: {
		height: 0,
		transition: 'all 0.25s ease-in-out'
	},

	errorShown: {
		height: '100%'
	}
});

var Name = function (_React$Component) {
	_inherits(Name, _React$Component);

	function Name() {
		var _ref;

		var _temp, _this, _ret;

		_classCallCheck(this, Name);

		for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
			args[_key] = arguments[_key];
		}

		return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Name.__proto__ || Object.getPrototypeOf(Name)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
			showFirstNameIsRequiredError: false,
			showLastNameIsRequiredError: false
		}, _this.handleCheckFirstNameValue = function (name) {
			_this.setState({ showFirstNameIsRequiredError: _this.props.required && !name });
		}, _this.handleCheckLastNameValue = function (name) {
			_this.setState({ showLastNameIsRequiredError: _this.props.required && !name });
		}, _this.handleChangeFirstName = function (firstName) {
			_this.handleCheckFirstNameValue(firstName);
			_this.props.handleChangeFirstName(firstName);
			return firstName;
		}, _this.handleChangeLastName = function (lastName) {
			_this.handleCheckLastNameValue(lastName);
			_this.props.handleChangeLastName(lastName);
			return lastName;
		}, _this.handleBlurFirstName = function (firstName) {
			_this.handleCheckFirstNameValue(firstName);
			_this.props.handleBlurFirstName(firstName);
		}, _this.handleBlurLastName = function (lastName) {
			_this.handleCheckLastNameValue(lastName);
			_this.props.handleBlurLastName(lastName);
		}, _temp), _possibleConstructorReturn(_this, _ret);
	}

	/**
 * Check for a first name value if it's required
 * @param {String} name - first name
 */


	/**
 * Check for a last name value if it's required
 * @param {String} name - last name
 */


	_createClass(Name, [{
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    firstNameErrorMessage = _props.firstNameErrorMessage,
			    lastNameErrorMessage = _props.lastNameErrorMessage;

			// define the wrapper classNames, which handle showing error messages

			var firstNameWrapperClassNames = (0, _classnames2.default)('col-md-6', {
				'vx_has-error-with-message': firstNameErrorMessage,
				'vx_has-error': !firstNameErrorMessage && this.state.showFirstNameIsRequiredError
			});
			var lastNameWrapperClassNames = (0, _classnames2.default)('col-md-6', {
				'vx_has-error-with-message': lastNameErrorMessage,
				'vx_has-error': !lastNameErrorMessage && this.state.showLastNameIsRequiredError
			});

			return _react2.default.createElement(
				'div',
				{ className: 'row' },
				_react2.default.createElement(
					'div',
					{ className: firstNameWrapperClassNames, style: { margin: '10px 0' } },
					_react2.default.createElement(_reactTextInput2.default, {
						name: 'firstName',
						id: 'firstName',
						className: 'vx_form-control vx_form-control_complex',
						label: this.props.firstNameLabel,
						required: this.props.required,
						value: this.props.firstNameDefaultValue,
						handleChange: this.handleChangeFirstName,
						handleFocus: function handleFocus(firstName) {
							return _this2.props.handleFocusFirstName(firstName);
						},
						handleBlur: this.handleBlurFirstName
					}),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage, firstNameErrorMessage && styles.errorShown), {
								'vx_form-control-message': firstNameErrorMessage
							}) },
						firstNameErrorMessage
					)
				),
				_react2.default.createElement(
					'div',
					{ className: lastNameWrapperClassNames, style: { margin: '10px 0' } },
					_react2.default.createElement(_reactTextInput2.default, {
						name: 'lastName',
						id: 'lastName',
						className: 'vx_form-control vx_form-control_complex',
						label: this.props.lastNameLabel,
						required: this.props.required,
						value: this.props.lastNameDefaultValue,
						handleChange: this.handleChangeLastName,
						handleFocus: function handleFocus(lastName) {
							return _this2.props.handleFocusLastName(lastName);
						},
						handleBlur: this.handleBlurLastName
					}),
					_react2.default.createElement(
						'div',
						{ className: (0, _classnames2.default)((0, _aphrodite.css)(styles.errorMessage, lastNameErrorMessage && styles.errorShown), {
								'vx_form-control-message': lastNameErrorMessage
							}) },
						lastNameErrorMessage
					)
				)
			);
		}
	}]);

	return Name;
}(_react2.default.Component);

Name.propTypes = {
	firstNameLabel: _propTypes2.default.string.isRequired,
	lastNameLabel: _propTypes2.default.string.isRequired,
	required: _propTypes2.default.bool,
	firstNameDefaultValue: _propTypes2.default.string,
	lastNameDefaultValue: _propTypes2.default.string,
	firstNameErrorMessage: _propTypes2.default.string,
	lastNameErrorMessage: _propTypes2.default.string,
	handleChangeFirstName: _propTypes2.default.func.isRequired,
	handleChangeLastName: _propTypes2.default.func.isRequired,
	handleFocusFirstName: _propTypes2.default.func,
	handleFocusLastName: _propTypes2.default.func,
	handleBlurFirstName: _propTypes2.default.func,
	handleBlurLastName: _propTypes2.default.func
};
Name.defaultProps = {
	handleFocusFirstName: function handleFocusFirstName() {},
	handleFocusLastName: function handleFocusLastName() {},
	handleBlurFirstName: function handleBlurFirstName() {},
	handleBlurLastName: function handleBlurLastName() {}
};
exports.default = Name;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/guest-payment/dist/components/Name.js
// module id = 702
// module chunks = 5